/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteCustomFieldDefinitionInput = {
    id?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteCustomFieldDefinitionMutationVariables = {
    input: DeleteCustomFieldDefinitionInput;
};
export type deleteCustomFieldDefinitionMutationResponse = {
    readonly deleteCustomFieldDefinition: {
        readonly deletedCustomFieldDefinitionId: string | null;
    } | null;
};
export type deleteCustomFieldDefinitionMutation = {
    readonly response: deleteCustomFieldDefinitionMutationResponse;
    readonly variables: deleteCustomFieldDefinitionMutationVariables;
};



/*
mutation deleteCustomFieldDefinitionMutation(
  $input: DeleteCustomFieldDefinitionInput!
) {
  deleteCustomFieldDefinition(input: $input) {
    deletedCustomFieldDefinitionId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteCustomFieldDefinitionInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteCustomFieldDefinitionPayload",
    "kind": "LinkedField",
    "name": "deleteCustomFieldDefinition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedCustomFieldDefinitionId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteCustomFieldDefinitionMutation",
    "operationKind": "mutation",
    "text": "mutation deleteCustomFieldDefinitionMutation(\n  $input: DeleteCustomFieldDefinitionInput!\n) {\n  deleteCustomFieldDefinition(input: $input) {\n    deletedCustomFieldDefinitionId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f8965de18e7dfd48b49d333d333621eb';
export default node;
